// rishab code
import React, { useState, useRef } from "react";
import "./LoginForm.scss";
import CustomTextBox from "../customTextBox/CustomTextBox";
import CustomButton from "../customButton/CustomButton";
import { ToastDisplayer } from "../toastDisplay/ToastDisplayer";
import { useAuth } from "../../contexts/auth";
import { LoadPanel, TextBox } from "devextreme-react";

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export default function LoginForm({ onForgotPassword, onRegisterClick }) {
  const { signIn } = useAuth();

  const [formData, setFormData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const [passwordVisible, setPasswordVisible] = useState(true);
  const handleInputChange = (name) => (e) => {
    const value = e;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleKeyDown = (e, name) => {
    e.stopPropagation();
    if (e.key === "Enter") {
      if (name === "email") {
        passwordRef.current.instance.focus();
      } else if (name === "password") {
        onLoginSubmit();
      }
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  const onLoginSubmit = async () => {
    const trimmedEmail = formData.email.trim();
    const trimmedPassword = formData.password.trim();

    if (!trimmedEmail || !validateEmail(trimmedEmail)) {
      return ToastDisplayer(
        "error",
        !trimmedEmail
          ? "Email address cannot be empty."
          : "Please enter a valid email address.",
      );
    }

    if (!trimmedPassword) {
      return ToastDisplayer("error", "Password cannot be empty.");
    }

    try {
      setLoading(true);
      const result = await signIn(trimmedEmail, trimmedPassword);

      ToastDisplayer(
        result.isOk ? "success" : "error",
        result.isOk ? "Login successful!" : result?.message,
      );
    } catch (error) {
      ToastDisplayer("error", "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div onKeyDown={(e) => handleKeyDown(e, "form")}>
      {loading && <LoadPanel visible={true} />}
      <div className="subHeader">
        Welcome! Please log in to your account
      </div>{" "}
      <div className="loginContent">
        <div className="MyTextBox">
          <div className="fieldsMain">
            <label className="TextBoxLabel" htmlFor="email">
              Email Address <span className="requiredClass">*</span>
            </label>
            <div className="TextBoxWrapper">
              <TextBox
                placeholder="Type your email address"
                value={formData.email}
                onValueChange={handleInputChange("email")}
                type="email"
                stylingMode="outlined"
                className="TextBoxMain"
                valueChangeEvent="keyup"
                ref={emailRef}
                onKeyDown={(e) => handleKeyDown(e.event, "email")}
              />
            </div>
          </div>
        </div>

        <div className="MyTextBox">
          <div className="fieldsMain">
            <label className="TextBoxLabel" htmlFor="password">
              Password <span className="requiredClass">*</span>
            </label>
            <div className="TextBoxWrapper">
              <TextBox
                placeholder="Type your password"
                value={formData.password}
                onValueChange={handleInputChange("password")}
                mode={passwordVisible ? "password" : "text"}
                stylingMode="outlined"
                className="TextBoxMain"
                valueChangeEvent="keyup"
                ref={passwordRef}
                onKeyDown={(e) => handleKeyDown(e.event, "password")}
              />
              <span className="eye-icon" onClick={togglePasswordVisibility}>
                <i
                  className={
                    passwordVisible ? "ri-eye-off-line" : "ri-eye-line"
                  }
                ></i>
              </span>
            </div>
          </div>
        </div>

        <div className="options">
          <div className="forgotPwdClass" onClick={onForgotPassword}>
            Forgot Password?
          </div>
        </div>

        <CustomButton
          text={"Login"}
          onClick={onLoginSubmit}
          disabled={loading}
        />
      </div>
      <div style={{ paddingTop: "10px" }}>
        <span>Don't have an account?&nbsp;</span>

        <span className="registerNewUser" onClick={onRegisterClick}>
          Create one
        </span>
      </div>
    </div>
  );
}
